import { getCustomQueries } from '@/helpers/queryHelper';
import {
  ADD_NOTES_CHAPTER_FAILED,
  ADD_NOTES_CHAPTER_REQUEST,
  ADD_NOTES_CHAPTER_SUCCEEDED,
  ADD_NOTES_CONTENT_FAILED,
  ADD_NOTES_CONTENT_REQUEST,
  ADD_NOTES_CONTENT_SUCCEEDED,
  ADD_NOTES_COURSE_FAILED,
  ADD_NOTES_COURSE_REQUEST,
  ADD_NOTES_COURSE_SUCCEEDED,
  ADD_NOTES_SUBJECT_FAILED,
  ADD_NOTES_SUBJECT_REQUEST,
  ADD_NOTES_SUBJECT_SUCCEEDED,
  DELETE_NOTES_CHAPTER_FAILED,
  DELETE_NOTES_CHAPTER_REQUEST,
  DELETE_NOTES_CHAPTER_SUCCEEDED,
  DELETE_NOTES_CONTENT_FAILED,
  DELETE_NOTES_CONTENT_REQUEST,
  DELETE_NOTES_CONTENT_SUCCEEDED,
  DELETE_NOTES_COURSE_FAILED,
  DELETE_NOTES_COURSE_REQUEST,
  DELETE_NOTES_COURSE_SUCCEEDED,
  DELETE_NOTES_SUBJECT_FAILED,
  DELETE_NOTES_SUBJECT_REQUEST,
  DELETE_NOTES_SUBJECT_SUCCEEDED,
  EDIT_NOTES_CHAPTER_FAILED,
  EDIT_NOTES_CHAPTER_REQUEST,
  EDIT_NOTES_CHAPTER_SUCCEEDED,
  EDIT_NOTES_CONTENT_FAILED,
  EDIT_NOTES_CONTENT_REQUEST,
  EDIT_NOTES_CONTENT_SUCCEEDED,
  EDIT_NOTES_COURSE_FAILED,
  EDIT_NOTES_COURSE_REQUEST,
  EDIT_NOTES_COURSE_SUCCEEDED,
  EDIT_NOTES_SUBJECT_FAILED,
  EDIT_NOTES_SUBJECT_REQUEST,
  EDIT_NOTES_SUBJECT_SUCCEEDED,
  GET_NOTES_CHAPTER_FAILED,
  GET_NOTES_CHAPTER_REQUEST,
  GET_NOTES_CHAPTER_SUCCEEDED,
  GET_NOTES_CONTENT_FAILED,
  GET_NOTES_CONTENT_REQUEST,
  GET_NOTES_CONTENT_SUCCEEDED,
  GET_NOTES_COURSE_BY_SLUG_REQUEST,
  GET_NOTES_COURSE_BY_SLUG_FAILED,
  GET_NOTES_COURSE_BY_SLUG_SUCCEEDED,
  GET_NOTES_COURSE_FAILED,
  GET_NOTES_COURSE_REQUEST,
  GET_NOTES_COURSE_SUCCEEDED,
  GET_NOTES_SUBJECT_FAILED,
  GET_NOTES_SUBJECT_REQUEST,
  GET_NOTES_SUBJECT_SUCCEEDED,
  SET_NOTES_DATA,
  SET_NOTES_EDIT_DATA,
  SET_NOTES_ERROR_DATA,
  GET_NOTES_SUBJECT_BY_SLUG_REQUEST,
  GET_NOTES_SUBJECT_BY_SLUG_SUCCEEDED,
  GET_NOTES_SUBJECT_BY_SLUG_FAILED,
  GET_NOTES_CHAPTER_BY_SLUG_REQUEST,
  GET_NOTES_CHAPTER_BY_SLUG_SUCCEEDED,
  GET_NOTES_CHAPTER_BY_SLUG_FAILED,
  CLEAR_NOTES_ERROR,
  GET_NOTES_CONTENT_BY_SLUG_REQUEST,
  GET_NOTES_CONTENT_BY_SLUG_SUCCEEDED,
  GET_NOTES_CONTENT_BY_SLUG_FAILED,
  GET_LANDING_NOTES_COURSE_REQUEST,
  GET_LANDING_NOTES_COURSE_SUCCEEDED,
  GET_LANDING_NOTES_COURSE_FAILED,
  GET_LANDING_NOTES_COURSE_DETAIL_REQUEST,
  GET_LANDING_NOTES_COURSE_DETAIL_SUCCEEDED,
  GET_LANDING_NOTES_COURSE_DETAIL_FAILED,
  GET_LANDING_NOTES_COURSE_BY_PAGE,
  GET_LANDING_NOTES_COURSE_BY_PAGE_SUCCEEDED,
  GET_LANDING_NOTES_COURSE_BY_PAGE_FAILED,
  GET_LANDING_NOTES_SUBJECT_DETAIL_REQUEST,
  GET_LANDING_NOTES_SUBJECT_DETAIL_SUCCEEDED,
  GET_LANDING_NOTES_SUBJECT_DETAIL_FAILED,
  GET_NOTES_CATEGORY_REQUEST,
  GET_NOTES_CATEGORY_SUCCEEDED,
  GET_NOTES_CATEGORY_FAILED,
  ADD_NOTES_CATEGORY_REQUEST,
  ADD_NOTES_CATEGORY_SUCCEEDED,
  ADD_NOTES_CATEGORY_FAILED,
  EDIT_NOTES_CATEGORY_REQUEST,
  EDIT_NOTES_CATEGORY_SUCCEEDED,
  EDIT_NOTES_CATEGORY_FAILED,
  DELETE_NOTES_CATEGORY_REQUEST,
  DELETE_NOTES_CATEGORY_SUCCEEDED,
  DELETE_NOTES_CATEGORY_FAILED,
  SEARCH_VIDEO,
  SEARCH_VIDEO_SUCCEEDED,
  SEARCH_VIDEO_FAILED,
  CLEAR_NOTES_COURSE_QUERY,
} from '.';

//NOTES COURSE
export const getNotesCourses = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_NOTES_COURSE_REQUEST,
    payload: {
      url: `note/course/?${query}`,
      onSuccess: GET_NOTES_COURSE_SUCCEEDED,
      onFailure: GET_NOTES_COURSE_FAILED,
    },
  };
};

export const searchCourseVideos = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: SEARCH_VIDEO,
    payload: {
      url: `content-video/?${query}`,
      onSuccess: SEARCH_VIDEO_SUCCEEDED,
      onFailure: SEARCH_VIDEO_FAILED,
    },
  };
};
export const getNotesCourseBySlug = (slug = {}) => {
  return {
    type: GET_NOTES_COURSE_BY_SLUG_REQUEST,
    payload: {
      url: `note/course/${slug}`,
      onSuccess: GET_NOTES_COURSE_BY_SLUG_SUCCEEDED,
      onFailure: GET_NOTES_COURSE_BY_SLUG_FAILED,
    },
  };
};
export const addNotesCourse = (data = {}) => {
  return {
    type: ADD_NOTES_COURSE_REQUEST,
    payload: {
      data,
      url: 'note/course/',
      onSuccess: ADD_NOTES_COURSE_SUCCEEDED,
      onFailure: ADD_NOTES_COURSE_FAILED,
    },
  };
};

export const editNotesCourse = (data = {}, slug = {}) => {
  return {
    type: EDIT_NOTES_COURSE_REQUEST,
    payload: {
      data,
      url: `note/course/${slug}/`,
      onSuccess: EDIT_NOTES_COURSE_SUCCEEDED,
      onFailure: EDIT_NOTES_COURSE_FAILED,
    },
  };
};

export const deleteNotesCourse = (id = {}) => {
  return {
    type: DELETE_NOTES_COURSE_REQUEST,
    payload: {
      url: `note/course/${id}`,
      onSuccess: DELETE_NOTES_COURSE_SUCCEEDED,
      onFailure: DELETE_NOTES_COURSE_FAILED,
    },
  };
};

//NOTES SUBJECT
export const getNotesSubjects = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_NOTES_SUBJECT_REQUEST,
    payload: {
      url: `note/subject/?${query}`,
      onSuccess: GET_NOTES_SUBJECT_SUCCEEDED,
      onFailure: GET_NOTES_SUBJECT_FAILED,
    },
  };
};

export const getNotesSubjectBySlug = (slug = {}) => {
  return {
    type: GET_NOTES_SUBJECT_BY_SLUG_REQUEST,
    payload: {
      url: `note/subject/${slug}`,
      onSuccess: GET_NOTES_SUBJECT_BY_SLUG_SUCCEEDED,
      onFailure: GET_NOTES_SUBJECT_BY_SLUG_FAILED,
    },
  };
};

export const addNotesSubject = (data = {}) => {
  return {
    type: ADD_NOTES_SUBJECT_REQUEST,
    payload: {
      data,
      url: 'note/subject/',
      onSuccess: ADD_NOTES_SUBJECT_SUCCEEDED,
      onFailure: ADD_NOTES_SUBJECT_FAILED,
    },
  };
};

export const editNotesSubject = (data = {}, slug = {}) => {
  return {
    type: EDIT_NOTES_SUBJECT_REQUEST,
    payload: {
      data,
      url: `note/subject/${slug}/`,
      onSuccess: EDIT_NOTES_SUBJECT_SUCCEEDED,
      onFailure: EDIT_NOTES_SUBJECT_FAILED,
    },
  };
};

export const deleteNotesSubject = (id = {}) => {
  return {
    type: DELETE_NOTES_SUBJECT_REQUEST,
    payload: {
      url: `note/subject/${id}`,
      onSuccess: DELETE_NOTES_SUBJECT_SUCCEEDED,
      onFailure: DELETE_NOTES_SUBJECT_FAILED,
    },
  };
};

//NOTES CHAPTER
export const getNotesChapters = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_NOTES_CHAPTER_REQUEST,
    payload: {
      url: `note/chapter/?${query}`,
      onSuccess: GET_NOTES_CHAPTER_SUCCEEDED,
      onFailure: GET_NOTES_CHAPTER_FAILED,
    },
  };
};

export const getNotesChapterBySlug = (slug = {}) => {
  return {
    type: GET_NOTES_CHAPTER_BY_SLUG_REQUEST,
    payload: {
      url: `note/chapter/${slug}`,
      onSuccess: GET_NOTES_CHAPTER_BY_SLUG_SUCCEEDED,
      onFailure: GET_NOTES_CHAPTER_BY_SLUG_FAILED,
    },
  };
};

export const addNotesChapter = (data = {}) => {
  return {
    type: ADD_NOTES_CHAPTER_REQUEST,
    payload: {
      data,
      url: 'note/chapter/',
      onSuccess: ADD_NOTES_CHAPTER_SUCCEEDED,
      onFailure: ADD_NOTES_CHAPTER_FAILED,
    },
  };
};

export const editNotesChapter = (data = {}, slug = {}) => {
  return {
    type: EDIT_NOTES_CHAPTER_REQUEST,
    payload: {
      data,
      url: `note/chapter/${slug}/`,
      onSuccess: EDIT_NOTES_CHAPTER_SUCCEEDED,
      onFailure: EDIT_NOTES_CHAPTER_FAILED,
    },
  };
};

export const deleteNotesChapter = (id = {}) => {
  return {
    type: DELETE_NOTES_CHAPTER_REQUEST,
    payload: {
      url: `note/chapter/${id}`,
      onSuccess: DELETE_NOTES_CHAPTER_SUCCEEDED,
      onFailure: DELETE_NOTES_CHAPTER_FAILED,
    },
  };
};

//NOTES CONTENT
export const getNotesContents = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_NOTES_CONTENT_REQUEST,
    payload: {
      url: `note/content/?${query}`,
      onSuccess: GET_NOTES_CONTENT_SUCCEEDED,
      onFailure: GET_NOTES_CONTENT_FAILED,
    },
  };
};

export const getNotesContentBySlug = (slug = {}) => {
  return {
    type: GET_NOTES_CONTENT_BY_SLUG_REQUEST,
    payload: {
      url: `note/content/${slug}`,
      onSuccess: GET_NOTES_CONTENT_BY_SLUG_SUCCEEDED,
      onFailure: GET_NOTES_CONTENT_BY_SLUG_FAILED,
    },
  };
};
export const addNotesContent = (data = {}) => {
  return {
    type: ADD_NOTES_CONTENT_REQUEST,
    payload: {
      data,
      url: 'note/content/',
      onSuccess: ADD_NOTES_CONTENT_SUCCEEDED,
      onFailure: ADD_NOTES_CONTENT_FAILED,
    },
  };
};

export const editNotesContent = (data = {}, slug = {}) => {
  return {
    type: EDIT_NOTES_CONTENT_REQUEST,
    payload: {
      data,
      url: `note/content/${slug}/`,
      onSuccess: EDIT_NOTES_CONTENT_SUCCEEDED,
      onFailure: EDIT_NOTES_CONTENT_FAILED,
    },
  };
};

export const deleteNotesContent = (id = {}) => {
  return {
    type: DELETE_NOTES_CONTENT_REQUEST,
    payload: {
      url: `note/content/${id}`,
      onSuccess: DELETE_NOTES_CONTENT_SUCCEEDED,
      onFailure: DELETE_NOTES_CONTENT_FAILED,
    },
  };
};

//NOTES CATEGORY
export const getNotesCategories = (data = {}) => {
  let query = getCustomQueries(data);

  return {
    type: GET_NOTES_CATEGORY_REQUEST,
    payload: {
      url: `note/category/?${query}`,
      onSuccess: GET_NOTES_CATEGORY_SUCCEEDED,
      onFailure: GET_NOTES_CATEGORY_FAILED,
    },
  };
};
export const addNotesCategory = (data = {}) => {
  return {
    type: ADD_NOTES_CATEGORY_REQUEST,
    payload: {
      data,
      url: 'note/category/',
      onSuccess: ADD_NOTES_CATEGORY_SUCCEEDED,
      onFailure: ADD_NOTES_CATEGORY_FAILED,
    },
  };
};

export const editNotesCategory = (data = {}, slug = {}) => {
  return {
    type: EDIT_NOTES_CATEGORY_REQUEST,
    payload: {
      data,
      url: `note/category/${slug}/`,
      onSuccess: EDIT_NOTES_CATEGORY_SUCCEEDED,
      onFailure: EDIT_NOTES_CATEGORY_FAILED,
    },
  };
};

export const deleteNotesCategory = (id = {}) => {
  return {
    type: DELETE_NOTES_CATEGORY_REQUEST,
    payload: {
      url: `note/category/${id}`,
      onSuccess: DELETE_NOTES_CATEGORY_SUCCEEDED,
      onFailure: DELETE_NOTES_CATEGORY_FAILED,
    },
  };
};

export const setNotesData = (data = {}) => {
  return {
    type: SET_NOTES_DATA,
    payload: {
      data,
    },
  };
};
export const setNotesEditData = (data = {}) => {
  return {
    type: SET_NOTES_EDIT_DATA,
    payload: { data },
  };
};

export const setNotesErrorData = (data = {}) => {
  return {
    type: SET_NOTES_ERROR_DATA,
    payload: {
      data,
    },
  };
};
export const clearNotesError = () => {
  return {
    type: CLEAR_NOTES_ERROR,
  };
};

//NOTES LANDING
export const getLandingNotesCourses = (data = {}) => {
  let query = getCustomQueries(data);
  return {
    type: GET_LANDING_NOTES_COURSE_REQUEST,
    payload: {
      url: `course-notes/?${query}`,
      onSuccess: GET_LANDING_NOTES_COURSE_SUCCEEDED,
      onFailure: GET_LANDING_NOTES_COURSE_FAILED,
    },
  };
};

export const getLandingNotesCoursesByPage = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_LANDING_NOTES_COURSE_BY_PAGE,
    payload: {
      url: `course-notes/?${query}`,
      onSuccess: GET_LANDING_NOTES_COURSE_BY_PAGE_SUCCEEDED,
      onFailure: GET_LANDING_NOTES_COURSE_BY_PAGE_FAILED,
    },
  };
};

export const getLandingNotesCourseDetails = ({ slug, data }) => {
  let query = getCustomQueries(data);

  return {
    type: GET_LANDING_NOTES_COURSE_DETAIL_REQUEST,
    payload: {
      url: `course-notes/${slug}/?${query}`,
      onSuccess: GET_LANDING_NOTES_COURSE_DETAIL_SUCCEEDED,
      onFailure: GET_LANDING_NOTES_COURSE_DETAIL_FAILED,
    },
  };
};
export const getLandingNotesSubjectDetails = (slug = {}) => {
  return {
    type: GET_LANDING_NOTES_SUBJECT_DETAIL_REQUEST,
    payload: {
      url: `subject-notes/${slug}`,
      onSuccess: GET_LANDING_NOTES_SUBJECT_DETAIL_SUCCEEDED,
      onFailure: GET_LANDING_NOTES_SUBJECT_DETAIL_FAILED,
    },
  };
};

export const clearNotesCourseQuery = () => {
  return {
    type: CLEAR_NOTES_COURSE_QUERY,
  };
};
